/**
 * DOM id for an in-page jump target.
 * A leading `#` is ignored. Blank values are omitted.
 * When both arguments are set, `anchorId` wins.
 */
export function resolveAnchorId(
  anchorId: string | undefined,
  id: string | undefined,
): string | undefined {
  const raw = anchorId ?? id;
  if (typeof raw !== 'string') return undefined;
  const trimmed = raw.trim().replace(/^#/, '');
  return trimmed.length > 0 ? trimmed : undefined;
}
